import { useContext } from "react";

import { AiOutlineRight } from "react-icons/ai";

import { ScopeRouteType } from "../../routes/MainRoutes";

import { ActionTypes, GlobalContextData } from "../../context";

import "./LeftNavBar.scss";
import { useScopedRoutes } from "../../hooks";
import { getUserData } from "../../shared/utils";
import {
  getFinanceAlertRecipientId,
  useFinanceAlertSummaryQuery,
} from "../../api/notifications";
import { CustomMenuItem } from "./CustomMenuItem";
import { SubMenuItem } from "./SubMenuItem";

export const LeftNavBar = () => {
  const { leftMenuScopedRoutes } = useScopedRoutes();

  const { state, dispatch } = useContext(GlobalContextData);

  const { data: financeAlertSummary } = useFinanceAlertSummaryQuery(
    getFinanceAlertRecipientId(state.userInfo ?? getUserData())
  );
  const legacyUnreadCount =
    state.inComingNotification?.filter((x: any) => x.read === false).length ?? 0;
  const alertCount = legacyUnreadCount + (financeAlertSummary?.unread ?? 0);

  return (
    <nav className={`sidebar ${state.openSidebar ? "" : "close"}`}>
      <header>
        <div
          className="toggle"
          onClick={() =>
            dispatch({
              type: ActionTypes.OPEN_CLOSE_SIDE_BAR,
              payload: !state.openSidebar,
            })
          }
        >
          <AiOutlineRight />
        </div>
      </header>

      <div className="menu-bar">
        <div className="menu">
          <ul className="menu-links">
            {leftMenuScopedRoutes &&
              Object.keys(leftMenuScopedRoutes).map(
                (groupKey: string, index) => {
                  return (
                    <div key={groupKey + "" + index} className="content-height">
                      {index > 0 && <hr className="horizontal-line" />}
                      {state.openSidebar && groupKey && (
                        <div className="menu-group">{groupKey}</div>
                      )}
                      {leftMenuScopedRoutes[groupKey].map(
                        (scopeRoute: ScopeRouteType, index: number) => {
                          return (
                            <div key={index + "" + groupKey}>
                              <CustomMenuItem
                                userData={getUserData()}
                                scopeRoute={scopeRoute}
                                state={state}
                                alertCount={alertCount}
                              />

                              {state.openSidebar &&
                                scopeRoute.subMenus !== undefined &&
                                scopeRoute.subMenus?.map(
                                  (subMenuItem, subIndex) => {
                                    return (
                                      <div
                                        key={`${
                                          subMenuItem.path ||
                                          subMenuItem.label ||
                                          subIndex
                                        }-submenu`}
                                        className="sub-menu-container"
                                      >
                                        <SubMenuItem
                                          userData={getUserData()}
                                          scopeRoute={subMenuItem}
                                          state={state}
                                        />
                                      </div>
                                    );
                                  }
                                )}
                            </div>
                          );
                        }
                      )}
                    </div>
                  );
                }
              )}
          </ul>
        </div>
      </div>
    </nav>
  );
};
